<script>
    import Icon from '$component/Icon.svelte';
    import {twMerge} from "tailwind-merge";

    const {
        class: cls = '',
        icon = '',
        suffixIcon = '',
        iconText = '',
        title,
        titleClass = ''
    } = $props();
</script>

<div class={twMerge("flex items-center gap-2.5", cls)}>
    {#if icon}
        <div class="flex items-center justify-center size-7 text-white bg-cyprus rounded-full shrink-0">
            <Icon name={icon} class="w-4 h-4 fill-current"/>
        </div>
    {:else if iconText}
        <div class="flex items-center justify-center size-7 text-white bg-cyprus rounded-full shrink-0">
            <span class="font-bold text-xs">{iconText}</span>
        </div>
    {/if}
    <span class={twMerge("font-bold text-base/6 grow", titleClass)}>{title}</span>
    {#if suffixIcon}
        <div class="text-cyprus p-1.5">
            <Icon name={suffixIcon} class="w-4 h-4 fill-current"/>
        </div>
    {/if}
</div>



